import { useApiClient } from '@/api/client.js'

export const FIRESTORE_CONFIG_FOR_WEB = '/core/v2/business_api/firestore/config/web/'

export function getFirestoreConfigForWeb () {
  const apiClient = useApiClient()

  return apiClient.post({
    url: FIRESTORE_CONFIG_FOR_WEB,
  })
}
